import { inject, Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivateFn,
    Router,
    RouterStateSnapshot,
} from '@angular/router';
import { productDetailRoute } from '../components/products/productdetail.component';
import { UserService } from '../generic/service/user.service';

@Injectable({
    providedIn: 'root',
})
export class LoggedInGuardService {
    protected router = inject(Router);
    protected userService = inject(UserService);


    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ): boolean {
        if (this.isShouldBeRedirectedToLogin(route, state)) {
            this.router.navigate(['/login'], {
                queryParams: { returnUrl: state.url },
            });

            return false;
        }

        return true;
    }

    /**
     * Determines if this is a valid, publicly accessible product detail url (which is the case if 'type' equals 0
     *
     * @param {ActivatedRouteSnapshot} route
     * @returns {boolean}
     */
    private static isValidPublicProductDetailRoute(
        route: ActivatedRouteSnapshot,
    ): boolean {
        return (
            route.routeConfig?.path === productDetailRoute &&
            route.params.type === '0'
        );
    }

    private isShouldBeRedirectedToLogin(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ): boolean {
        if (LoggedInGuardService.isValidPublicProductDetailRoute(route)) {
            return false;
        }

        if (this.userService.isLoggedIn()) {
            return false;
        }

        return state.url !== '/login';
    }
}

export const loggedInGuard: CanActivateFn = (
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
): boolean => inject(LoggedInGuardService).canActivate(next, state);
